import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        await refresh();
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Sign-in failed";
        navigate("/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[80vh] grid place-items-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-black border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-neutral-600">Signing you in…</p>
      </div>
    </div>
  );
}
